import { makeAutoObservable } from 'mobx'
import { ServiceTabsType } from '../types/admin-table.types'

export type RequestsTabType =
  | 'все заявки'
  | 'назначены'
  | 'приняты'
  | 'в работе'
  | 'установка'
  | 'установленные'
  | 'не выполненные'

class AdminServiceTabStore {
  tab: ServiceTabsType = 'все заявки'
  requestsTab: RequestsTabType = 'все заявки'

  constructor() {
    makeAutoObservable(this)
  }

  setTab = (tab: ServiceTabsType) => {
    this.tab = tab
  }

  setRequestsTab = (tab: RequestsTabType) => {
    this.requestsTab = tab
  }

  clearRequestsTab = () => {
    this.requestsTab = 'назначены'
  }

  clear = () => {
    this.tab = 'все заявки'
  }
}

export const adminServiceTabStore = new AdminServiceTabStore()
